import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../types/firebase';
import { signOut } from 'firebase/auth';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const NAV_LINKS = [
  { label: 'Guest Table', path: '/admin' },
  { label: 'Statistics', path: '/admin/stats' },
  { label: 'Gifts', path: '/gifts' },
] as const;

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  const pageTitle = path.includes('/gifts')
    ? 'Gifts'
    : path.includes('/stats')
      ? 'Guest Statistics'
      : 'Admin Dashboard';

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="p-8 max-w-7xl mx-auto mt-20">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-8">
        <h1 className="text-gray-800 m-0">{pageTitle}</h1>
        <div className="flex flex-wrap gap-3">
          {NAV_LINKS.map(({ label, path: linkPath }) => {
            const active = path === linkPath;
            return (
              <button
                key={linkPath}
                type="button"
                onClick={() => navigate(linkPath)}
                disabled={active}
                className={`border-none py-2 px-4 rounded transition-colors duration-200 ${
                  active
                    ? 'bg-gray-800 text-white cursor-default'
                    : 'bg-gray-600 hover:bg-gray-700 text-white cursor-pointer'
                }`}
              >
                {label}
              </button>
            );
          })}
          <button
            type="button"
            onClick={handleSignOut}
            className="bg-red-600 hover:bg-red-700 text-white border-none py-2 px-4 rounded cursor-pointer transition-colors duration-200"
          >
            Sign Out
          </button>
        </div>
      </div>
      {children}
    </div>
  );
};

export default AdminLayout;
